var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 22.3334H7.23984C3.65317 22.3334 1.6665 20.3601 1.6665 16.7601V7.24008C1.6665 3.65341 3.63984 1.66675 7.23984 1.66675H13.3332C16.9198 1.66675 18.9065 3.64008 18.9065 7.24008C18.9065 7.78675 18.4532 8.24008 17.9065 8.24008C17.3598 8.24008 16.9065 7.78675 16.9065 7.24008C16.9065 4.73341 15.8398 3.66675 13.3332 3.66675H7.23984C4.73317 3.66675 3.6665 4.73341 3.6665 7.24008V16.7601C3.6665 19.2667 4.73317 20.3334 7.23984 20.3334H10.6665C11.2132 20.3334 11.6665 20.7867 11.6665 21.3334C11.6665 21.8801 11.2132 22.3334 10.6665 22.3334Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7599 30.3334H18.6666C15.0799 30.3334 13.0933 28.3601 13.0933 24.7601V15.2401C13.0933 11.6534 15.0666 9.66675 18.6666 9.66675H24.7599C28.3466 9.66675 30.3333 11.6401 30.3333 15.2401V24.7601C30.3333 28.3601 28.3599 30.3334 24.7599 30.3334ZM18.6666 11.6667C16.1599 11.6667 15.0933 12.7334 15.0933 15.2401V24.7601C15.0933 27.2667 16.1599 28.3334 18.6666 28.3334H24.7599C27.2666 28.3334 28.3333 27.2667 28.3333 24.7601V15.2401C28.3333 12.7334 27.2666 11.6667 24.7599 11.6667H18.6666Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1732 21H19.8398C19.2932 21 18.8398 20.5467 18.8398 20C18.8398 19.4533 19.2932 19 19.8398 19H24.1732C24.7198 19 25.1732 19.4533 25.1732 20C25.1732 20.5467 24.7198 21 24.1732 21Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.1732C21.4533 23.1732 21 22.7198 21 22.1732V17.8398C21 17.2932 21.4533 16.8398 22 16.8398C22.5467 16.8398 23 17.2932 23 17.8398V22.1732C23 22.7198 22.5467 23.1732 22 23.1732Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditem);
export default __webpack_public_path__ + "static/media/additem.a326e37a1a1f25016d77a32636a3c070.svg";
export { ForwardRef as ReactComponent };